import { call, put } from 'redux-saga/effects';
import Http from '../../../../../libs/Http';

export function* fetchDocumentation(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const response = yield call(Http.get, '/documentation/documentation', {
    query: {
      type: payload.type,
    }
  });
  yield put({
    type: 'SET_DOCUMENTATION',
    payload: {
      documentation: response.documentation,
    }
  });
  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* updateDocumentation(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield call(Http.post, '/documentation/update', {
    body: {
      id: payload.id,
      text: payload.text,
    }
  });
  yield put({
    type: 'FETCH_DOCUMENTATION',
    payload: {
      type: payload.type,
    },
  });

  meta && meta.onComplete && meta.onComplete();

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* addComment(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield call(Http.post, '/documentation/addComment', {
    body: {
      username: payload.username,
      key: payload.key,
      comment: payload.comment,
    }
  });
  yield put({
    type: 'FETCH_DOCUMENTATION',
    payload: {
      type: payload.type,
    },
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* deleteComment(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield call(Http.delete, '/documentation/comment', {
    body: {
      id: payload.id,
    },
  });
  yield put({
    type: 'FETCH_DOCUMENTATION',
    payload: {
      type: payload.type,
    },
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export default function* ({ takeFirst, takeLatest, takeEvery }) {
  yield [
    takeEvery('FETCH_DOCUMENTATION', fetchDocumentation),
    takeEvery('UPDATE_DOCUMENTATION', updateDocumentation),
    takeEvery('ADD_COMMENT', addComment),
    takeEvery('DELETE_COMMENT', deleteComment),
  ];
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/Documentation/Documentation.sagas.js